import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';
import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';
import { EditorBookingItemEditStore } from '../editor-booking-item-edit/editor-booking-item-edit.store';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    selector: 'eas-editor-booking-item-option',
    templateUrl: './editor-booking-item-option.component.html',
    styleUrls: ['./editor-booking-item-option.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemOptionComponent implements OnInit {
  @Input() itemOption: EditorBookingItem;
  @Input() itemOptionIndex: number;
  @Input() levelLines: boolean[];

  constructor(
    private itemTreeStore: EditorBookingItemTreeStore,
    private itemEditStore: EditorBookingItemEditStore,
    private itemDialogStore: EditorDialogStore
  ) {

  }

  ngOnInit() {

  }

  onToggleShowSettings() {
    this.itemTreeStore.setShowSettings(this.itemOption.id, !this.itemOption.showSettings);
    return false;
  }

  onEdit() {
    this.itemEditStore.startEditing(this.itemOption.id, null);
    this.itemDialogStore.editBookingItem();
    return false;
  }

  onMoveUp() {
    this.itemTreeStore.moveItemUp(this.itemOption.id);
    return false;
  }

  onMoveDown() {
    this.itemTreeStore.moveItemDown(this.itemOption.id);
    return false;
  }

  onDelete() {
    this.itemTreeStore.deleteItem(this.itemOption.id);
    return false;
  }

  onDuplicate() {
    this.itemTreeStore.duplicateItem(this.itemOption.id);
    return false;
  }

  onAddSibling() {
    this.itemTreeStore.addItemAfter(this.itemOption.id);
    return false;
  }

  onAddChild() {
    this.itemTreeStore.addItem(this.itemOption.id);
    return false;
  }

  onEditNameList() {
    this.itemTreeStore.startEditingNameList(this.itemOption.id);
    return false;
  }

  getBookableBadgeTitle() {
    return this.itemOption.userCanBook() ? $localize `Bookable` : $localize `Not bookable`;
  }

  getBookableBadgeVariant() {
    return this.itemOption.userCanBook() ? 'success' : 'none';
  }

  getSettingsButtonTitle() {
    return this.itemOption.showSettings ? $localize `Hide settings` : $localize `Show settings`;
  }
}
